import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import Table from "../../components/table";
import SelectDropdown from "../../components/common/SelectDropdown";
import statusModel from "../../models/status.model";
import { PiEyeLight } from "react-icons/pi";
import { Link } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import { LiaEdit, LiaTrashAlt } from "react-icons/lia";

const Html = ({
  sorting,
  filter,
  view,
  statusChange,
  pageChange,
  count,
  clear,
  filters,
  data,
  changestatus,
  isAllow,
  total = { total },
  sortClass,
  handleSearch,
  deleteCard,
  edit,
  categories,
  subCategories,
  handleCategory,
  envelopes,
}) => {

  const columns = [
    {
      key: "name",
      name: "Name",
      render: (row) => {
        return <span className="capitalize pointer" onClick={(e) => view(row?.id || row?._id)}>{row?.name}</span>;
      },
    },
    {
      key: "categoryDetail",
      name: "Category",
      render: (row) => {
        return <span className="capitalize" >{row?.categoryDetail?.name || "--"}</span>;
      },
    },
    {
      key: "subCategoryDetail",
      name: "Sub Category",
      render: (row) => {
        return <span className="capitalize" >{row?.subCategoryDetail?.name || "--"}</span>;
      },
    },
    {
      key: "envelopeDetail",
      name: "Front Image",
      render: (row) => {
        return <>
        <span className="capitalize" >{row?.envelopeDetail?.name || "--"}</span>
          {/* {row?.envelope_name?.length != 0 ?
            <div className="flex gap-2 flex-wrap items-center">
              {row?.envelope_name?.map((item, index) => {
                return <span className="capitalize bg-yellow-100  text-xs text-center  w-28 text-yellow-800 px-2 border border-yellow-300 gap-2 rounded" key={index}>{item}</span>
              })}
            </div> : "--"
          } */}
        </>
      },
    },
    {
      key: "price",
      name: "Price",
      render: (row) => {
        return <span >{row?.price ? `${row?.price} USD` : "--"}</span>;
      },
    },
    {
      key: "status",
      name: "Status",
      render: (row) => {
        return (
          <>
            <div className="w-32" onClick={() => statusChange(row)}>
              <span className={` cursor-pointer text-sm !px-3 h-[30px] w-[100px] cursor-pointer flex items-center justify-center border border-[#EBEBEB] text-[#fff] !rounded capitalize ${row.status == "deactive" ? " bg-gray-200 text-black" : "bg-[#F58D18] "}`}>
                {row.status == "deactive" ? "inactive" : "active"}
              </span>
            </div>
          </>
        );
      },
    },
    {
      key: "action",
      name: "Actions",
      render: (itm) => {
        return (
          <>
            <div className="flex items-center justify-start gap-1.5">
              {isAllow("readCards") && (
                <Tooltip placement="top" title="View">
                  <a className="border cursor-pointer  hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg" onClick={(e) => view(itm?.id || itm?._id)}>
                    <PiEyeLight />
                  </a>
                </Tooltip>
              )}
              {isAllow("editCards") &&
                <Tooltip placement="top" title="Edit">
                  <a className="border cursor-pointer hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg" onClick={(e) => edit(itm?.id || itm?._id)}>
                    <LiaEdit />
                  </a>
                </Tooltip>
              }
              {isAllow("deleteCards") &&
                <Tooltip placement="top" title="Delete">
                  <span className="border cursor-pointer hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg" onClick={() => deleteCard(itm?.id || itm?._id)}>
                    <LiaTrashAlt />
                  </span>
                </Tooltip>
              }
            </div>
          </>
        );
      },
    },
  ];

  return (
    <Layout>
      <div className="flex flex-wrap justify-between items-center gap-y-4">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">Cards</h3>
        </div>
        <div className="flex">
          <Link className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-[#fff] rounded-lg gap-2" to={`/card/add`}>
            <FiPlus className="text-xl text-[#fff]" /> Add Card
          </Link>
        </div>
      </div>

      <div className="shadow-box w-full bg-white rounded-lg mt-6">
        <div className="flex p-4 items-center flex-wrap">
          <form className="flex items-center max-w-sm" onSubmit={(e) => { e.preventDefault(); filter(); }}>
            <label htmlFor="simple-search" className="sr-only">Search</label>
            <div className="relative w-full">
              <input
                type="text"
                id="simple-search"
                value={filters?.search}
                onChange={(e) => handleSearch(e)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-[#F58D18]block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500 pr-10"
                placeholder="Search"
                required
              />
              {filters?.search && (
                <i className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm" aria-hidden="true" onClick={(e) => clear()}></i>
              )}
            </div>
            <button type="submit" className="p-2.5 m-2 text-sm font-medium text-[#222222d6] bg-blue-700 rounded-lg border border-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
              <span className="sr-only">Search</span>
            </button>
          </form>

          <div className="flex gap-2 ml-auto">
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters?.status}
              result={(e) => { changestatus(e.value, "status") }}
              options={statusModel.list}
            />
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Categories"
              intialValue={filters?.categoryId}
              result={(e) => handleCategory(e?.value)}
              options={categories}
            />
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Sub Categories"
              intialValue={filters?.subCategoryId}
              result={(e) => { changestatus(e.value, "subCategoryId") }}
              options={subCategories}
            />
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Front Image"
              intialValue={filters?.envelopeId}
              result={(e) => { changestatus(e.value, "envelopeId") }}
              options={envelopes}
            />
            {filters?.status || filters?.categoryId || filters?.subCategoryId || filters?.envelopeId ?
              <button className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg" onClick={() => clear()}>
                Reset
              </button> : null
            }
          </div>
        </div>

        <>
          <Table
            className="mb-3"
            data={data}
            columns={columns}
            page={filters.page}
            count={filters.count}
            filters={filters}
            nodata="No Cards Yet"
            total={total}
            result={(e) => {
              if (e.event == "page") pageChange(e.value);
              if (e.event == "count") count(e.value);
            }}
          />
        </>
      </div>
    </Layout>
  );
};

export default Html;
